import React from 'react';
import { Popover, PopoverAction } from 'components/Popover';
import { usePopoverState } from 'reakit';
import { useAuthState } from 'modules/Auth/AuthContext';
import { WorkspaceItem } from 'components/UniversalSearch/components/WorkspaceItem/WorkspaceItem';
import { selectorSectionStyled, selectorSectionTitleStyled, selectorWrapperStyled } from 'components/UniversalSearch/components/WorkspaceSelector/WorkspaceSelector.styled';
type WorkspaceSelectorProps = {
  currentWorkspaceId?: string;
  onSelectWorkspaceId?: (userOrOrgId?: string) => void;
};
export const WorkspaceSelector: React.FC<WorkspaceSelectorProps> = ({
  currentWorkspaceId,
  onSelectWorkspaceId
}) => {
  const {
    authData
  } = useAuthState();
  const popover = usePopoverState({
    placement: 'bottom-start'
  });
  const organizations = authData?.organizations || [];
  const onSelectWorkspace = (userOrOrgData?: CF.LocalUserWithOrgUserAndPlan | CF.API.Organizations.UserOrganization) => {
    const userOrOrgId = userOrOrgData ? 'organization' in userOrOrgData ? userOrOrgData.organization.id : userOrOrgData.user_id : undefined;
    onSelectWorkspaceId?.(userOrOrgId);
    popover.hide();
  };
  if (!authData || !organizations.length) return null;
  const currentWorkspace = authData.user_id === currentWorkspaceId ? authData : organizations.find(org => org.organization.id === currentWorkspaceId);
  return <>
      <PopoverAction popover={popover}>
        <WorkspaceItem userOrOrgData={currentWorkspace} withArrow={popover.visible ? 'up' : 'down'} />
      </PopoverAction>
      <Popover data-testid="account-popover" aria-label="Account" popover={popover} className={selectorWrapperStyled}>
        <section className={selectorSectionStyled}>
          <p className={selectorSectionTitleStyled}>PERSONAL WORKSPACE</p>
          <WorkspaceItem userOrOrgData={authData} active={authData.user_id === currentWorkspaceId} onWorkspaceSelect={onSelectWorkspace} />
        </section>
        <section className={selectorSectionStyled}>
          <p className={selectorSectionTitleStyled}>ORGANIZATIONS</p>
          {organizations.map(orgItem => <WorkspaceItem active={orgItem.organization.id === currentWorkspaceId} key={orgItem.organization.id} onWorkspaceSelect={onSelectWorkspace} userOrOrgData={orgItem} />)}
          <WorkspaceItem active={undefined === currentWorkspaceId} key="community" onWorkspaceSelect={onSelectWorkspace} userOrOrgData={undefined} />
        </section>
      </Popover>
    </>;
};